import React from 'react';
import PortalLogin from '@/components/PortalLogin';

// TEAM (Total Employee Access & Management) login. Uses the shared PortalLogin
// template. The TEAM application is not yet available, so only existing
// administrators proceed into the ecosystem; other valid users see a localized
// "coming soon" notice (gate handled inside PortalLogin).
const TeamLogin = () => <PortalLogin portal="team" />;

export default TeamLogin;
